function init_walkanim(from_php){
    var main=$(".place.walkanim");
    var canvWrap=main.find(".canvWrap");
    var canv=main.find("#canvQJS");

    var mapCur,zoomCur;
    var wasLoaded=0;

    var resources={};

    if(_ON_DEV){
        console.table(from_php);
    }

    if(typeof from_php.girl_ids=="undefined" ||  from_php.girl_ids.length==0){
        return false;
    }
    var app = new PIXI.Application({
        width: 1280, height: 780,antialias: true,transparent:true,
        view:canv[0]
    });
    var loaderSemaphore= new mySemaphore({timeout:0});
    loaderSemaphore.use(1);

    var textObj;

    $.addToPlacePreloader(function(){
            //on load
//        _moduleEvents.trigger("loadEnd");
    },[],{addToLoader:1});


    var conf_all={
        "def":{
            pos:[0,0],
            size:[0,0],
            anim_arr:["animation0","animation1","animation2"]
        },
        "alice":{
            pos:[2220,888],
            size:[306,330],
            min:{
                scale:88,
                pos_real:[305,104]
            }
        },
        "anya":{
            pos:[762,800],
            size:[294,210]
        },
        "ashley":{
            pos:[1121,434],
            size:[150,156]
        },
        "cherry":{
            pos:[54,250],
            size:[160,284],
            big:{
                pos_real:[10,10],
            }
        },
        "cindy":{
            pos:[430,294],
            size:[78,208],
            anim_arr:["animation","animation2","animation3"]
        },
        "dora":{
            pos:[508,304],
            size:[94,204]
        },
        "emma":{
            pos:[1476,586],
            size:[200,160]
        },
        "frecly":{
            pos:[758,515],
            size:[108,168],
            anim_arr:["animation","animation1","animation2"]
        },
        "geeky":{
            pos:[1390,726],
            size:[146,220]
        },
        "ice":{
            pos:[1184,610],
            size:[190,128],
        },
        "indira":{
            pos:[1298,276],
            size:[114,114],
            min:{
                scale:80,
                pos_real:[235,31],
                anim_arr:["animation0","animation1"]
            }
        },
        "linn":{
            pos:[1376,984],
            size:[244,464]
        },
        "lola":{
            pos:[1918,534],
            size:[118,240]
        },
        "maggie":{
            pos:[628,342],
            size:[230,140]
        },
        "pantress":{
            pos:[328,1134],
            size:[288,240]
        },
        "sanshi":{
            pos:[248,974],
            size:[234,226],
            anim_arr:["animation","animation2","animation3"]
        },
        "twins":{
            pos:[790,1012],
            size:[481,396],
            big:{
                cover:1
            }
        },
        "victoria":{
            pos:[1036,310],
            size:[100,122]
        },
        "winona":{
            pos:[138,682],
            size:[338,146],
            big:{
                cover:1
            }
        },
        "zoe":{
            pos:[8,950],
            size:[270,286]
        }
    };


    var covers_arr=[
        {url:_IMG_SERV+"/gfx/place/walkanim/cover1.png",pos:[546,1285]},
        {url:_IMG_SERV+"/gfx/place/walkanim/cover2.png",pos:[34,552]},
        {url:_IMG_SERV+"/gfx/place/walkanim/cover3.png",pos:[2489,801]}
    ];


//    from_php.girl_ids=[1];

    function addToLoader(name,path,girl_name_cur){

        var version="";
        if(girl_name_cur=="victoria"){
            version="?1";
//            $.qLog(version+" ");
        }
        var spineLoaderOptions = { metadata: { spineAtlasSuffix: '.atlas'+version } };
        loaderMain.add(name,path+version,spineLoaderOptions);
    }


    var loaderMain = new PIXI.loaders.Loader();
    var i,girl_id,girl_name;
    loaderMain.add("back",_IMG_SERV+"/gfx/place/walkanim/back.jpg");
    for(i in from_php.girl_ids){
        girl_id=from_php.girl_ids[i];
        girl_name=$.takeGirlImage(girl_id);
        addToLoader("girl"+girl_id,_IMG_SERV+"/gfx/place/walkanim/girls/"+girl_name+"/anim_small/skeleton.json",girl_name);

    }
    for(i in covers_arr){
        loaderMain.add("cover_"+i,covers_arr[i].url);
    }
    if(from_php.girl_id){
        girl_name=$.takeGirlImage(from_php.girl_id);
        addToLoader("big_"+girl_name+"_spine",_IMG_SERV+"/gfx/place/walkanim/girls/"+girl_name+"/anim_big/skeleton.json",girl_name);
        loaderMain.add("big_"+girl_name+"_back",_IMG_SERV+"/gfx/place/walkanim/girls/"+girl_name+"/back.jpg");
        if(typeof conf_all[girl_name]!="undefined" && typeof conf_all[girl_name].big!="undefined"
                && typeof conf_all[girl_name].big.cover!="undefined" && conf_all[girl_name].big.cover){
            loaderMain.add("big_"+girl_name+"_cover",_IMG_SERV+"/gfx/place/walkanim/girls/"+girl_name+"/cover.png");
        }

        loaderSemaphore.useFun(function(){
            mapCur.centerGirl(from_php.girl_id);
            zoomCur.showGirl($.takeGirlImage(from_php.girl_id),1);
        });
    }
    else{
        loaderSemaphore.useFun(function(){

        });
    }


    girlOne=function(girl_id,qconf,resources){
        PIXI.Container.call(this,{});
        var girl_name=$.takeGirlImage(girl_id);

        qconf=$.extend(true,{
            step_arr:[1,2],
            img:"girl"+girl_id,
            size_name:"min"
        },qconf);

        var conf_one=conf_all.def;

        if(typeof conf_all[girl_name]!="undefined"){
            conf_one=$.extend(true,{},conf_all.def,conf_all[girl_name]);
        }
        if(typeof conf_one[qconf.size_name]!="undefined"){
            conf_one=$.extend(true,{},conf_one,conf_one[qconf.size_name])
        }


        this.anim_arr=conf_one.anim_arr;


        this.qtype=0;
        this.step_max=mt_rand(qconf.step_arr[0],qconf.step_arr[1]);
        this.step=mt_rand(0,this.step_max);
        this.conf_cur=qconf;
        var scale=100;
        if(typeof conf_one.scale!="undefined"){
            scale=conf_one.scale;
        }

        var thc=this;

        myPixiElement.spine.call(this,{
            img:qconf.img,
            spine_conf:{
                anim_name:this.anim_arr[0],
                anim_loop:true,
                spineResource:resources,
                scale:scale,
                onAnimComplete:function(){
                    thc.step++;
                    if(thc.step>=thc.step_max){
                        thc.step=0;
                        if(thc.qtype==0){
                            thc.qtype=1;
                            thc.step_max=1;
                            thc.playAnim(thc.anim_arr[mt_rand(0,thc.anim_arr.length-1)]);
                        }
                        else{
                            thc.qtype=0;
                            thc.step_max=mt_rand(qconf.step_arr[0],qconf.step_arr[1]);
                            thc.playAnim(thc.anim_arr[0]);
                        }
                    }
                }
            }
        });
        if(typeof conf_one.pos_real!="undefined"){
            this.x=conf_one.pos_real[0];
            this.y=conf_one.pos_real[1];
        }

    };
    girlOne.prototype = Object.create(myPixiElement.spine.prototype);
    girlOne.prototype=$.extend(girlOne.prototype,{
    });


    function mapZoom(conf){
        PIXI.Container.call(this,{});
        this.girlWasLoaded=[];

        this.backObj = new PIXI.Graphics();
        this.backObj.beginFill(0xFFFFFF);
        this.backObj.drawRect(0, 0, 1280, 780);

        this.animCont= new PIXI.Container();

        this.backCont=new myPixiElement.container({});

        this.backCont.alpha=0;
        this.backCont.addChild(this.backObj);



        this.addChild(this.animCont);
        this.addChild(this.backCont);
        this.current_state="all";
        this.fadeSemaphore=new mySemaphore({timeout:0});


    }
    mapZoom.prototype = Object.create(PIXI.Container.prototype);
    mapZoom.prototype=$.extend(mapZoom.prototype,{
        tryToLoad:function(girl_name,on_succ){
            if(typeof resources["big_"+girl_name+"_back"]!="undefined"){
                on_succ();
                return true;
            }
            if(!loaderSemaphore.use()){
                return false;
            }

            addToLoader("big_"+girl_name+"_spine",_IMG_SERV+"/gfx/place/walkanim/girls/"+girl_name+"/anim_big/skeleton.json",girl_name);

            loaderMain.add("big_"+girl_name+"_back",_IMG_SERV+"/gfx/place/walkanim/girls/"+girl_name+"/back.jpg");

            if(typeof conf_all[girl_name]!="undefined" && typeof conf_all[girl_name].big!="undefined"
                    && typeof conf_all[girl_name].big.cover!="undefined" && conf_all[girl_name].big.cover){
                loaderMain.add("big_"+girl_name+"_cover",_IMG_SERV+"/gfx/place/walkanim/girls/"+girl_name+"/cover.png")
            }



            var thc=this;

            loaderMain.load(function(loader, r){
                var i;
                for(i in r){
                    resources[i]=r[i];
                }
                thc.girlWasLoaded.push(girl_name);
                loaderSemaphore.clear();
                on_succ();
            });
            return true;

        },
        privUseCointainer:function(girl_name,quick){
//            this.animCont.destroy();
//            this.animCont=new PIXI.Container();
            this.animCont.alpha=1;
            this.animCont.removeChildren();


            this.animCont.addChild(new myPixiElement.img({img:"big_"+girl_name+"_back",anchor:[0,0]}));
            this.animCont.addChild(
                new girlOne($.takeGirlId(girl_name),{img:"big_"+girl_name+"_spine",size_name:"big"},resources)
            );
            if(typeof resources["big_"+girl_name+"_cover"]!="undefined"){
                this.animCont.addChild(new myPixiElement.img({img:"big_"+girl_name+"_cover",anchor:[0,0]}));
            }



            var thc=this;
            function qFun(){
                thc.current_state="girl";
            }
            if(quick){
                thc.backCont.alpha=0;
                qFun();
            }
            else{
                this.backCont.fadeOut(15,{onEnd:function(){
                    qFun();
                }});
            }

        },
        showGirl:function(girl_name,quick){
            var thc=this;
            this.animCont.alpha=0;

            this.fadeSemaphore.use();
            function qFun(){
                thc.fadeSemaphore.useFun(function(){
                    thc.privUseCointainer(girl_name,quick);
                });
            }
            if(quick){
                qFun();
            }
            else{
                thc.backCont.fadeIn(15,{onEnd:
                    function(){
                        qFun();
                    }
                });
            }

            this.tryToLoad(girl_name,function(){
               thc.fadeSemaphore.clear();
            });
        },
        hideGirl:function(){
            var thc=this;
            this.backCont.fadeIn(15,{onEnd:function(){
                thc.animCont.alpha=0;
                thc.current_state="all";
                thc.backCont.fadeOut(15,{onEnd:function(){

                }});

            }});
        },
        myUpdate:function(delta){
            this.backCont.myUpdate(delta);
        }
    });

    function mapWalk(conf){
        PIXI.Container.call(this);
        conf=$.extend(true,{
            size:[2560,1560],
        },conf);
        this.conf=conf;


        this.range_all=[-(conf.size[0]-1280),-(conf.size[1]-780)];

        this.x=this.range_all[0]/2;
        this.y=this.range_all[1]/2;

//            this.mainCointainer.x=left_all;

    }
    mapWalk.prototype = Object.create(PIXI.Container.prototype);
    mapWalk.prototype=$.extend(mapWalk.prototype,{
        init:function(){
            this.prepareMove();
        },
        centerGirl:function(girl_id){
            if(!girl_id){
               return false;
            }
            var girl_name=$.takeGirlImage(girl_id);
            var conf=conf_all[girl_name];
            var pos=[-conf.pos[0],-conf.pos[1]];
            pos[0]+=1280/2-conf.size[0]/2;
            pos[1]+=780/2-conf.size[1]/2;

            var i;
            for(i=0;i<2;i++){
                pos[i]=Math.max(pos[i],this.range_all[i]);
                pos[i]=Math.min(pos[i],0);
            }

            this.x=pos[0];
            this.y=pos[1];
        },
        clickOne:function(pos){
            var girl_name,bum,choose="";
            for(girl_name in conf_all){
                bum=conf_all[girl_name];
                if(
                    pos[0]>bum.pos[0] && pos[0]<bum.pos[0]+bum.size[0]
                    &&
                    pos[1]>bum.pos[1] && pos[1]<bum.pos[1]+bum.size[1]
                    &&
                    in_array($.takeGirlId(girl_name),from_php.girl_ids)
                ){
                    choose=girl_name;
                }
            }
            if(choose==""){
                return false;
            }
            zoomCur.showGirl(choose);
            textObj.afterClick();
//            conf_all
        },
        prepareMove:function(){
            var can_move=0,pos_start=[0,0];

            var qpos=[this.range_all[0]/2,this.range_all[1]/2];
            var click_pos=[0,0];


            var thc=this;


            function qStart(pos){
                if(can_move==0 && zoomCur.current_state=="all"){
                    pos_start=copyArray(pos);
                    click_pos=copyArray(pos);
                    can_move=1;
                }
            }
            function qMove(pos){

                var i;

                if(can_move && zoomCur.current_state=="all"){
                    qpos=[thc.x,thc.y];

//                    thc.x=qpos[0];
//                    thc.y=qpos[1];
                    for(i=0;i<2;i++){
                        qpos[i]=qpos[i]-(pos_start[i]-pos[i])*2;
                        qpos[i]=Math.max(qpos[i],thc.range_all[i]);
                        qpos[i]=Math.min(qpos[i],0);
                    }

                    thc.x=qpos[0];
                    thc.y=qpos[1];
                    textObj.afterClick();
                    pos_start=copyArray(pos);
                }
            }
            function qEnd(){
                can_move=0;
                if(lengthVectorPow(minusVector(pos_start,click_pos))<200 && zoomCur.current_state=="all"){
                    thc.clickOne([click_pos[0]-thc.x,click_pos[1]-thc.y]);
                }
            }


            canvWrap.on("mousemove",function(e){
                qMove([$.getXeventOffset(e),$.getYeventOffset(e)]);
            }).on("mousedown",function(e){
                qStart([$.getXeventOffset(e),$.getYeventOffset(e)]);
            }).on("mouseup",function(){
                qEnd();
            });
            var touchObj=new addTouch(canvWrap[0],{
                onStart:function(arr){
                    qStart(arr[0]);
                },
                onMove:function(arr){
                    qMove(arr[0]);
                },
                onEnd:function(){
                    qEnd();
                },
            });

        },
        test:function(){
            var i,obj;
            for(i in conf_all){
                if(i!="def"){
                    obj=conf_all[i];
                    var graphics = new PIXI.Graphics();
                    // set the line style to have a width of 5 and set the color to red
                    graphics.lineStyle(1, 0xFF0000);

                    // draw a rectangle
                    graphics.drawRect(obj.pos[0], obj.pos[1], obj.size[0], obj.size[1]);

                    this.addChild(graphics);
                }
            }

        }
    });
    function textOne(){
        var txt=from_php.lang_howto;
        if(!txt){
            txt="";
        }
        txt=txt.replace("<br>","\n");
        myPixiObj.showText.call(this,txt,{
            font_color:"#ffffff",
            font_size:30,
            pos:[640,720],
            "border_color":"#31153f",
            border_size:3,
            anchor:[0.5,1]
        });
    }
    textOne.prototype = Object.create(myPixiObj.showText.prototype);
    textOne.prototype=$.extend(textOne.prototype,{
        afterClick:function(){
            this.step_max=30;
            this.step_max_fadeout=30;
        }
    });


    loaderMain.load(function(loader, resourcesQ){

        resources=resourcesQ;

        mapCur=new mapWalk({});
        mapCur.init();
        app.stage.addChild(mapCur);

        textObj=new textOne();
        app.stage.addChild(textObj);


        zoomCur=new mapZoom({});
        app.stage.addChild(zoomCur);




        mapCur.addChild(new myPixiElement.img({img:"back",anchor:[0,0]}));

        for(i in from_php.girl_ids){
            girl_id=from_php.girl_ids[i];

            mapCur.addChild(
                new girlOne(girl_id,{},resources)
            );
        }

        for(i in covers_arr){
            mapCur.addChild(new myPixiElement.img({
                img:"cover_"+i,anchor:[0,0],
                pos:[covers_arr[i].pos[0],covers_arr[i].pos[1]]
            }));
        }

//        mapCur.test();

        $.triggerPlacePreloader(1);
        loaderSemaphore.clear();
        wasLoaded=1;

        app.ticker.add(
            function(delta){
                zoomCur.myUpdate(delta);
                textObj.update(delta);
            }
        );

        //zoomCur
    });

    main.find("#exitJS").click(function(){
        var th=$(this);
        if(wasLoaded && zoomCur.current_state=="girl"){
            zoomCur.hideGirl();

        }
        else{
            $.goToLocation(from_php.link);
        }
    });

    _mySound.playSound("beach_background");


    _moduleEvents.one("moduleClear",function(){
        _mySound.stopSound("beach_background");
        if(typeof app!="undefined" && app!=null){
            app.destroy();
        }
        if(typeof loaderMain.reset!="undefined"){
            loaderMain.reset();
        }
    });
}
